import { render, staticRenderFns } from "./NsSocialIcons.vue?vue&type=template&id=198ec94b&scoped=true&"
import script from "./NsSocialIcons.vue?vue&type=script&lang=js&"
export * from "./NsSocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./NsSocialIcons.vue?vue&type=style&index=0&id=198ec94b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ec94b",
  null
  
)

export default component.exports